import { makeStyles } from '@material-ui/core/styles';

const useAppbarStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& .MuiAppBar-colorPrimary': {
      borderTopColor: theme.palette.primary.main,
      borderTopWidth: 8,
      margin: 0,
      padding: 0,
    },
  },
  active: {
    color: theme.palette.secondary.main,
  },
  menuIcon: {
    fontSize: 36,
    mixBlendMode: 'difference',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  navigation: {
    flexGrow: 1,
    height: 100,
    textTransform: 'uppercase',
    display: 'flex',
    aligntItems: 'center',
  },
  navigationLink: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    height: 100,
    display: 'flex',
    alignItems: 'center',
    '&:first-child': {
      paddingLeft: theme.spacing(0),
    },

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,
    },
  },
  navigationTitle: {
    backgroundColor: theme.palette.primary.main,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    height: 100,
  },
  avatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  iconContainer: {
    backgroundColor: theme.palette.primary.main,
    height: 100,
    display: 'flex',
    justifyItems: 'center',
    transition: 'background-color 0.3s ease',
    '& .MuiIconButton-root': {
      color: theme.palette.secondary.main,
    },
    '&:hover': {
      '& .MuiIcon-root': {
        color: theme.palette.secondary.main,
      },
      '& .MuiIconButton-root': {
        color: theme.palette.primary.main,
      },
      backgroundColor: theme.palette.secondary.main,
    },
  },
  logo: {
    marginTop: 20,
    height: 60,
    paddingLeft: 10,
    paddingRigth: 10,
  },
  drawerContent: {
    width: 'auto',
    backgroundColor: theme.palette.primary.main,
  },
}));

export default useAppbarStyles;
